import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BodyM } from '@sorare/core/src/atoms/typography';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Countdown } from 'components/market/Countdown';
import { earlyAccessEvents, formatLaunchDate } from 'lib/earlyAccess';

const Wrapper = styled(Vertical).attrs({ gap: 2, center: true })`
  margin: calc(var(--unit) * 5) 0;
  text-align: center;
  color: var(--c-neutral-1000);
`;

const CapitalizedBodyM = styled(BodyM)`
  text-transform: capitalize;
`;

const Image = styled.img`
  width: 150px;
  @media ${laptopAndAbove} {
    width: 220px;
  }
`;

type Props = {
  filter: (typeof VIRTUAL_TOGGLE_FILTERS)[keyof typeof VIRTUAL_TOGGLE_FILTERS];
};

export const EmptyEarlyAccess = ({ filter }: Props) => {
  const { locale } = useIntlContext();
  const item = earlyAccessEvents.find(e => e.searchParams === filter?.name);
  if (!item) return null;
  return (
    <Wrapper>
      <Image src={item.cards} />
      <BodyL color="var(--c-neutral-600)">
        <FormattedMessage
          id="marketplace.emptyEarlyAccess"
          defaultMessage="2024-25 {competition} cards are coming soon"
          values={{
            competition: item.displayName,
          }}
        />
      </BodyL>
      <CapitalizedBodyM color="var(--c-neutral-600)">
        {formatLaunchDate(item.startDate, locale)}
      </CapitalizedBodyM>
      <Countdown endDate={item.startDate} expanded={false} />
    </Wrapper>
  );
};
